import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';

const ClozeOptions = ({
	rightSectionProps: { questionId, wordbank },
	isFeedback,
	dataContainer,
}) => {
	const [wordCollection, setWordCollection] = useState(null);
	useEffect(() => {
		if (!isFeedback) {
			appendScript('wordCloudNew');
		}
		return () => {
			removeScript('wordCloudNew');
		};
	}, [isFeedback, wordbank]);

	useEffect(() => {
		if (!!wordbank) {
			console.log('wordbank ', wordbank)
			wordbank = 'Choose|' + wordbank;
			let splittedWords = wordbank.split('|');
			setWordCollection(
				Object.keys(splittedWords).map(function (bankKey) {
					return (
						<li data-container={dataContainer} key={`${bankKey}_${questionId}`}>
							{splittedWords[bankKey]}
						</li>
					);
				}),
			);
		}
	}, [dataContainer, questionId, wordbank]);

	return (
		<div className="converse-options">
			<div className="quiz-area-options dropdown-content">
				<div className="arrow">
					<span className="down-arrow ccMoveOptions" data-direction="down" data-id={dataContainer}></span>
					<span className="up-arrow ccMoveOptions" data-direction="up" data-id={dataContainer}></span>

				</div>

				<ul className='dropdown-content-list' data-id={dataContainer}>{wordCollection}</ul>

			</div>
			<span className="reload"></span>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { rightSectionProps, isFeedback } = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		isFeedback,
	};
};

export default connect(mapStateToProps)(ClozeOptions);
